'use strict';

(function () {
  var subMenu = document.querySelector('.menu__sub-menu');

  if (!subMenu) {
    return;
  }

  var body = document.body; // eslint-disable-line prefer-destructuring
  var parentMenuItem = document.querySelectorAll('.menu__item--parent > a');
  var classes = {
    tabbing: 'js-menu-is-tabbing',
    visible: 'js-submenu-is-visible'
  };

  parentMenuItem.forEach(function (item) {
    var lastSubMenuItem = item.parentNode.querySelector('.menu__sub-menu__item:last-of-type');

    // on focus
    item.addEventListener('focus', function (e) {
      item.parentNode.classList.add(classes.visible);
      body.classList.add(classes.tabbing);
    });

    // tab back
    item.addEventListener('keydown', function (e) {
      if (e.shiftKey && e.keyCode == 9) {
        item.parentNode.classList.remove(classes.visible);
        body.classList.remove(classes.tabbing);
      }
    });

    // last item tab off
    lastSubMenuItem.addEventListener('keydown', function (e) {
      if (e.keyCode === 9) {
        item.parentNode.classList.remove(classes.visible);
        body.classList.remove(classes.tabbing);
      }
    });
  });

  // on click off
  body.addEventListener('click', function (e) {
    if (body.classList.contains(classes.tabbing)) {
      body.classList.remove(classes.tabbing);

      parentMenuItem.forEach(function (item) {
        item.parentNode.classList.remove(classes.visible);
      });
    }
  });
})();